module.exports = __webpack_public_path__ + "img/2021-08.c9287e9b.jpg";